<template> 
    <div>
        <v-card>            
            <v-card-text v-if="$store.state.qlikAuthenticated">
                <iframe style="position:absolute; top:0; left:0; bottom:0; right:0; width:100%; height:90vh; border:none; margin:0; padding:0; overflow:hidden" :src="$store.state.qlikUrl"></iframe>                
            </v-card-text>
        </v-card>
    </div>    
</template>

<script>

export default {
    mounted: function()
    {
        if (!window.location.host.startsWith("localhost"))
        {
            if (this.$store.state.qlikToken != null)
            {
                const jwt = this.$store.state.qlikToken;
                const url = this.$store.state.qlikUrl;
                const xmlHttpRequest = new XMLHttpRequest();
                const self = this;
                xmlHttpRequest.open("GET", url, true);
                xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + jwt);
                xmlHttpRequest.withCredentials = true;
                xmlHttpRequest.onreadystatechange = function ()
                {
                    if(xmlHttpRequest.readyState === XMLHttpRequest.DONE)
                    {
                        const status = xmlHttpRequest.status;
                        if (status === 200)
                            self.$store.state.qlikAuthenticated = true;                    
                    }
                }
                xmlHttpRequest.send();
            }
        }
    },

    methods:
    {
      gotoQlik()
      {
          const jwt = this.$store.state.qlikToken;
          const url = this.$store.state.qlikUrl;
          const start = Date.now();

          console.debug('[Dashboards] gotoQlik start', { url, tokenPresent: !!jwt, time: new Date(start).toISOString() });

          try {
              const xmlHttpRequest = new XMLHttpRequest();
              const self = this;

              xmlHttpRequest.open("GET", url, true);
              xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + jwt);
              xmlHttpRequest.withCredentials = true;
              xmlHttpRequest.timeout = 10000; // 10s

              xmlHttpRequest.onreadystatechange = function ()
              {
                  if (xmlHttpRequest.readyState === XMLHttpRequest.DONE)
                  {
                      const duration = Date.now() - start;
                      const status = xmlHttpRequest.status;
                      console.debug('[Dashboards] gotoQlik response', { status, durationMs: duration });

                      if (status === 200) {
                          console.debug('[Dashboards] authentication succeeded');
                          self.$store.state.qlikAuthenticated = true;
                      } else {
                          console.warn('[Dashboards] authentication failed', { status, responseSnippet: xmlHttpRequest.responseText && xmlHttpRequest.responseText.slice(0, 200) });
                      }
                  }
              };

              xmlHttpRequest.onerror = function (ev) {
                  console.error('[Dashboards] gotoQlik network error', ev);
              };

              xmlHttpRequest.ontimeout = function () {
                  console.error('[Dashboards] gotoQlik timeout after', Date.now() - start, 'ms');
              };

              xmlHttpRequest.send();
          } catch (err) {
              console.error('[Dashboards] gotoQlik exception', err);
          }
        }

    }
};
</script>